import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/core/state/app-config/app-config.service';
import { AppConfigState } from 'src/app/core/state/app-config/app-config.store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {
    configTheme: string = 'swimbird';
    unsubscribe$ = new Subject();

    constructor(appConfigService: AppConfigService) {
        appConfigService
            .get()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((config) => this.setThemeFromConfig(config));
    }

    ngOnDestroy() {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    setThemeFromConfig(config: AppConfigState) {
        switch (config.cssTheme) {
            case 'naps-theme':
                this.configTheme = 'naps';
                return;
            case 'carnegie-theme':
            case 'crng-theme':
                this.configTheme = 'carnegie';
                return;
        }
    }
}
